import * as React from 'react';
import styled from 'styled-components';

export type HeaderProps = {
  display: 'h1' | 'h2' | 'h3';
};

const BaseHeader = styled.div<HeaderProps>`
  margin-top: 0;
`;

// @ts-ignore
const H1 = styled(BaseHeader)`
  font-size: 32px;
  margin-bottom: 16px;
`;

// @ts-ignore
const H2 = styled(BaseHeader)`
  font-size: 24px;
  margin-bottom: 16px;
`;

// @ts-ignore
const H3 = styled(BaseHeader)<HeaderProps>`
  font-size: 20px;
  margin-bottom: 8px;
`;

export const Header: React.FC<React.HTMLAttributes<HTMLDivElement> &
  HeaderProps> = ({ children, display, ...props }) => {
  switch (display) {
    case 'h1':
      return (
        // @ts-ignore
        <H1 as={display} {...props}>
          {children}
        </H1>
      );

    case 'h2':
      return (
        // @ts-ignore
        <H2 as={display} {...props}>
          {children}
        </H2>
      );

    case 'h3':
      return (
        // @ts-ignore
        <H3 as={display} {...props}>
          {children}
        </H3>
      );

    default:
      return null;
  }
};
